/*
 * SeatFit reviews summary: big average + stars + count, star split, and the Fit/Quality sliders.
 * Every number comes from seatfit-reviews-index.json (the owner's imported list); Fit/Quality only
 * render when some reviews carry those scores, so nothing is shown that the data does not hold.
 * Needs seatfit-reviews-card-render.js (primitives) loaded first.
 */
(function () {
  'use strict';
  var NS = window.SeatFitReviews = window.SeatFitReviews || {};
  if (NS.summary || !NS.render) return;
  var R = NS.render;
  var el = R.el;
  var num = R.num;
  var fmt1 = R.fmt1;
  var stars = R.stars;
  var scale = R.scale;
  var countLabel = R.countLabel;

  // parts = {summary, score, dist, scales}; index = seatfit-reviews-index.json
  function summary(parts, index, L, opts) {
    var total = Number(index.total) || 0;
    parts.score.textContent = '';
    parts.score.appendChild(el('b', 'sf-rv-score__avg', fmt1(index.avg)));
    var col = el('span', 'sf-rv-score__col');
    col.appendChild(stars(index.avg, 'sf-rv-stars--big'));
    col.appendChild(el('small', 'sf-rv-score__count', countLabel(total, L)));
    parts.score.appendChild(col);

    parts.dist.textContent = '';
    var dist = index.dist;
    parts.dist.hidden = !(opts.showDist && dist && total > 0);
    if (!parts.dist.hidden) {
      for (var r = 5; r >= 1; r--) {
        var n = Number(dist[r] || dist[String(r)] || 0);
        var row = el('p', 'sf-rv-dist__row');
        row.setAttribute('aria-label', r + ' stars: ' + n);
        row.appendChild(el('span', 'sf-rv-dist__star', r + '★'));
        var bar = el('span', 'sf-rv-dist__bar');
        var fill = el('i', 'sf-rv-dist__fill');
        fill.style.width = (n / total * 100) + '%';
        bar.appendChild(fill);
        row.appendChild(bar);
        row.appendChild(el('span', 'sf-rv-dist__n', String(n)));
        parts.dist.appendChild(row);
      }
    }

    parts.scales.textContent = '';
    var ends = [L.poor, L.excellent];
    [['fit', L.fit], ['quality', L.quality]].forEach(function (k) {
      var s = index[k[0]];
      if (opts.showScales && s && s.count > 0 && num(s.avg) != null) parts.scales.appendChild(scale(k[1], s.avg, ends, true));
    });
    parts.scales.hidden = !parts.scales.childNodes.length;
    parts.summary.classList.toggle('sf-rv-summary--3', !parts.dist.hidden && !parts.scales.hidden);
    parts.summary.hidden = false;
  }

  NS.summary = summary;
})();
